import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from "rxjs";
import { ConfigParamService } from "../config-param/config-param.service";
import { UserInfoService } from './user-info/user-info.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const userInfoService = inject(UserInfoService);
  const configParamService = inject(ConfigParamService);
  const router = inject(Router);

  const frontendPagePermissions = configParamService.getConfigParamByParamName('frontendPagePermissions');
  if (frontendPagePermissions === undefined) {
    console.error("page permissions undefined");
    return false;
  }
  const pagePermissions = JSON.parse(frontendPagePermissions.paramValueString);
  return userInfoService.refreshUserInfoIfUndefined().pipe(
    map(userInfo => {
      if (userInfo === undefined) {
        return router.parseUrl('/login');
      }
      const { memberOf } = userInfo;
      if (memberOf === undefined) {
        return router.parseUrl('/no-permission');
      }
      const path = route.url[0].path;
      if (path === 'dashboard') {
        return true;
      }
      const groups = pagePermissions[path];
      if (!groups) {
        return false;
      }
      return memberOf.some((ai: string) => groups.includes(ai));
    }),
    catchError(() => {
      return of(false);
    })
  );
};